import { Box, ListItemButton, ListItemText, Paper } from "@mui/material";
import { useState } from "react";
import Home from "./Home";
import PlayList from "./PlayList";
import Favorite from "./Favorite";
import HomeIcon from '@mui/icons-material/Home';
import FavoriteIcon from '@mui/icons-material/Favorite';
import QueueMusicIcon from '@mui/icons-material/QueueMusic';
import HistoryIcon from '@mui/icons-material/History';
import SettingsIcon from '@mui/icons-material/Settings';
import LogoutIcon from '@mui/icons-material/Logout';
import History from "./History";
import Settings from "./Settings";
import logo from '../images/EUMAK.png';
import { useNavigate } from "react-router-dom";
import DialogBox from "../component/DialogBox";
import { useAudio } from "../component/AudioProvider"; // ✅ import this from the correct path



const AppView = () => {
    const navigate = useNavigate();
    const [Component, setComponent] = useState(<Home />);
    const [open, setOpen] = useState(false);
    const [selectedPath, setSelectedPath] = useState("");
    const { pauseTrack } = useAudio(); // ✅ access pauseTrack

    // useEffect(() => {
    //     console.log(localStorage.getItem("user"));
    //     if (localStorage.getItem("user") === null) {
    //         navigate("/auth");
    //     }
    // },)

    const handleConfirm = () => {
        // localStorage.clear();
        navigate("/auth");
        setOpen(false);
        pauseTrack();               // ✅ call pauseTrack when logging out
    };

    const handleCancel = () => {
        setOpen(false);
    };

    const menus = [
        {
            name: "Home",
            path: "/home"
        },
        {
            name: "Favorite",
            path: "/favorite"
        },
        {
            name: "Playlist",
            path: "/playlist"
        },
        {
            name: "Settings",
            path: "/settings"
        },
        {
            name: "History",
            path: "/history"
        },
        {
            name: "Logout",
            path: "/logout"
        },
    ];

    const loadComponent = (path) => {
        switch (path) {
            case "/home":
                setComponent(<Home />);
                setSelectedPath(path);
                break;
            case "/favorite":
                setComponent(<Favorite />);
                setSelectedPath(path);
                break;
            case "/playlist":
                setComponent(<PlayList />);
                setSelectedPath(path);
                break;
            case "/settings":
                setComponent(<Settings />);
                setSelectedPath(path);
                break;
            case "/history":
                setComponent(<History />);
                setSelectedPath(path);
                break;
            case "/logout":
                // Handle logout logic here
                setOpen(true);
                // setComponent(<Login />);
                // setSelectedPath(path);
                break;
            default:
                setComponent(<Home />);
                setSelectedPath(path);
                break;
        }
    };

    // const handleLogout = async () => {
        // try {
        //     // OPTIONAL: Call backend API to logout
        //     await fetch("http://localhost:8080/api/logout", {
        //         method: "POST",
        //         credentials: "include", // very important if using cookies
        //     });

        //     // After successful logout, redirect to login page
        // navigate("/auth");
        // } catch (error) {
        //     console.error("Logout failed:", error);
        // }
    // };


    return (
        <Box sx={{
            width: "100%",
            height: "100vh",
            display: "flex",
            borderRadius: "0.5rem"
        }}>
            <DialogBox
                open={open}
                title="Logout"
                message="Are you sure you want to Logout?"
                onConfirm={handleConfirm}
                onCancel={handleCancel}
            />
            <Box sx={{
                width: "20%",
                height: "100vh",
            }}>
                <Paper elevation={3} sx={{
                    height: "100vh"
                }}>

                    <Box sx={{
                        height: "87px",
                        display: "flex",
                        paddingLeft: "20px",
                        alignItems: "center",
                        fontSize: "50px",
                        background: "#181818",
                        color: "	#F0F3F5",
                        mb: 2,
                    }}>

                        <img src={logo} alt="Logo" style={{ width: "100px", height: "150px", paddingTop: "10px" }} />
                        <h5>EUMAK</h5>
                    </Box>

                    {menus.map((menu) => (
                        <ListItemButton
                            key={menu.path}
                            sx={{
                                backgroundColor: selectedPath === menu.path ? '#333333' : 'white',
                                color: selectedPath === menu.path ? 'white' : 'black',
                                '&:hover': {
                                    backgroundColor: 'gray',
                                    color: '#fff',
                                    '& svg': {
                                        color: 'black', // Icon color on hover
                                    },
                                },
                            }}
                            onClick={() => {
                                // if (menu.name === "Logout") {
                                //     handleLogout();
                                // } else {
                                    loadComponent(menu.path);
                                // }
                            }}
                        >
                            <ListItemText>
                                <Box sx={{ display: "flex", alignItems: "center", gap: "10px", padding: "5px", }}>
                                    {menu.name === "Home" && <HomeIcon />}
                                    {menu.name === "Favorite" && <FavoriteIcon />}
                                    {menu.name === "Playlist" && <QueueMusicIcon />}
                                    {menu.name === "History" && <HistoryIcon />}
                                    {menu.name === "Settings" && <SettingsIcon />}
                                    {menu.name === "Logout" && <LogoutIcon />}
                                    {menu.name}
                                </Box>
                            </ListItemText>


                        </ListItemButton>
                    ))}
                </Paper>

            </Box>
            <Box sx={{ width: "80%", height: "100vh", overflowY: "hidden", }}>
                {Component}
            </Box>
        </Box>
    );
}

export default AppView;